module.exports = __webpack_public_path__ + "media/images/career_camp/hero-26e349139346dbb4cc8f31d2a12c302b.png";